import React from 'react';
import styled from 'styled-components';

const Link = styled.a`
  text-decoration: underline;
`;

const TermsOfUse = () => {
  return (
    <TermsText>
      By signing up, I agree to the Kindbody{' '}
      <Link target="_blank" href="https://kindbody.com/privacy-policy/">
        Privacy Policy
      </Link>{' '}
      &{' '}
      <Link target="_blank" href="https://kindbody.com/terms-of-service/">
        Terms of Service
      </Link>
    </TermsText>
  );
};

export default TermsOfUse;

const TermsText = styled.div`
  max-width: 600px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    max-width: 340px;
    text-align: center;
  }
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.night};
  text-transform: uppercase;
`;
